import { render } from "./EmailSvg.vue?vue&type=template&id=5928dfd0"
import script from "./EmailSvg.vue?vue&type=script&lang=ts"
export * from "./EmailSvg.vue?vue&type=script&lang=ts"
script.render = render

export default script